import styled from "styled-components";

export const WorkStyle = styled.div`
  div.workContainer {
    margin: 3rem 5%;
    div.workHeader {
      font-size: 3rem;
      color: #dbb765;
      border: 5px solid #8f6e25;
      border-top: none;
      border-right: none;
      width: max-content;
      text-align: center;
      margin: 0 auto;
      padding: 0.5rem;
      font-weight: 600;
      @media screen and (max-width: 600px) {
        font-size: 2rem;
      }
    }
    div.projects {
      height: 27rem;
      width: 37rem;
      margin: 1.5rem auto 0.2rem;
      /* background: #33528f; */
      color: grey;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      transition: all 0.5s ease-in-out;
      border: 1px solid #8fb4ff;
      @media screen and (max-width: 500px) {
        height: 30rem;
      }
      h1 {
        font-size: 3.2rem;
        font-weight: 400;
        /* border-bottom: 1px solid black; */
        color: #658cdb;
        width: 100%;
        text-align: center;
        @media screen and (max-width: 830px) {
          font-size: 2.5rem;
        }
        @media screen and (max-width: 570px) {
          font-size: 2rem;
        }
        @media screen and (max-width: 460px) {
          font-size: 1.8rem;
        }
        @media screen and (max-width: 420px) {
          font-size: 1.4rem;
          margin-top: 0.3rem;
        }
      }
      div.summary {
        font-size: 1.8rem;
        /* margin-top: 1.5rem; */
        padding: 1.5rem 0.5rem 0;
        color: #8fb4ff;
        height: 14rem;

        @media screen and (max-width: 500px) {
          line-height: 1.1;
          height: 12rem;
        }
        @media screen and (max-width: 420px) {
          height: 10rem;
        }
        span {
          font-size: 1.2rem;
          opacity: 0.6;
          font-style: italic;
          width: 100%;

          @media screen and (max-width: 830px) {
            font-size: 1.5rem;
          }
          @media screen and (max-width: 570px) {
            font-size: 1.2rem;
            margin-top: 1rem;
          }
          @media screen and (max-width: 500px) {
            font-size: 1.1rem;
          }
          @media screen and (max-width: 460px) {
            margin-top: 1rem;
          }
          @media screen and (max-width: 420px) {
            font-size: 0.9rem;
            margin-top: 0.8rem;
          }
        }
      }
      div.techUsed {
        font-size: 1.3rem;
        margin: 1rem auto 0;
        color: #2bc6de;
        span {
          color: #d99696;
        }
        @media screen and (max-width: 570px) {
          font-size: 1rem;
          margin-top: 1rem;
        }
        @media screen and (max-width: 460px) {
          font-size: 0.9rem;
          margin-top: 1rem;
        }
        @media screen and (max-width: 420px) {
          font-size: 0.8rem;
          margin-top: 0.7rem;
        }
      }
      div.actionBtn {
        margin: 1.5rem auto 0;
        width: 97%;
        button {
          width: 47%;
          height: 2rem;
          margin: 0 1.5%;
          font-size: 1.5rem;
          div {
            display: flex;
            justify-content: center;
            align-items: center;
            svg {
              font-size: 1.6rem;
              padding-left: 5px;
              @media screen and (max-width: 460px) {
                font-size: 1.2rem;
              }
            }
          }
          &:hover {
            cursor: pointer;
            background: #2bc6de;
            color: #fff;
            border: none;
            outline: none;
          }
          @media screen and (max-width: 460px) {
            font-size: 1.3rem;
            height: 1.5rem;
          }
        }
        @media screen and (max-width: 460px) {
          margin-top: 1rem;
        }
      }
      &:hover {
        /* z-index: 5;
        border: none; */
      }

      @media screen and (max-width: 830px) {
        height: 25rem;
        width: 30rem;
      }
      @media screen and (max-width: 650px) {
        height: 27rem;
        width: 25rem;
      }
      @media screen and (max-width: 570px) {
        height: 25rem;
        width: 22rem;
      }
      @media screen and (max-width: 500px) {
        height: 22rem;
        width: 20rem;
      }
      @media screen and (max-width: 460px) {
        height: 21rem;
        width: 19rem;
      }
      @media screen and (max-width: 420px) {
        height: 19rem;
        width: 19rem;
      }
    }

    .splide__progress {
      background: #ccc;
      width: 35rem;
      margin: 0rem auto;
      position: absolute;
      top: 6rem;
      left: 50%;
      transform: translateX(-50%);
      @media screen and (max-width: 830px) {
        width: 30rem;
      }
      @media screen and (max-width: 650px) {
        width: 25rem;
      }
      @media screen and (max-width: 570px) {
        width: 22rem;
      }
      @media screen and (max-width: 500px) {
        width: 20rem;
      }
      @media screen and (max-width: 460px) {
        width: 19rem;
      }
      @media screen and (max-width: 420px) {
        width: 19rem;
        top: 4rem;
      }
    }

    .splide__progress__bar {
      background: #8fb4ff;
      height: 2px;
      transition: width 200ms ease;
      width: 35rem;
      margin: 0rem auto;
      @media screen and (max-width: 830px) {
        width: 30rem;
      }
      @media screen and (max-width: 650px) {
        width: 25rem;
      }
      @media screen and (max-width: 570px) {
        width: 22rem;
      }
      @media screen and (max-width: 500px) {
        width: 20rem;
      }
      @media screen and (max-width: 460px) {
        width: 19rem;
      }
      @media screen and (max-width: 420px) {
        width: 19rem;
      }
    }
    button.splide__arrow {
      font-size: 3rem;
      background: #5ac9db;

      @media screen and (max-width: 1024px) {
        font-size: 2.2rem;
      }
      @media screen and (max-width: 900px) {
        font-size: 1.8rem;
      }
      @media screen and (max-width: 780px) {
        font-size: 1.4rem;
      }
      @media screen and (max-width: 620px) {
        font-size: 1.1rem;
      }
      @media screen and (max-width: 480px) {
        font-size: 0.9rem;
      }
      @media screen and (max-width: 400px) {
        display: none;
      }
    }
  }
`;
